async function getGift() {
  try {
    const resData = await window.axios.get('/api/v1/admin/gifts/daily');
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function setGift(params) {
  try {
    const resData = await window.axios.put('/api/v1/admin/gifts/daily', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { setGift, getGift };
